import { generatePath, useHistory } from 'react-router-dom'
import { mdiArrowRight, mdiLicense } from '@mdi/js'

import routes from 'app/routes'
import { useAppSelector } from 'app/hooks'

import CommonLinkButton from 'components/Button/CommonLinkButton'
import { useHomeRouteParams } from 'features/home/hooks'
import { homeAddedLicensesSelector } from 'features/home/selectors'
import type { LicenseType } from 'features/licenses/types'
import { prettyLicenseDescription } from 'features/licenses/utils'
import Carousel from 'components/Carousel'
import { SubInfoBody } from '../styles'
import { StyledIcon } from '../../styles'
import {
  AppliedLicensesEmpty,
  AppliedLicensesHeader,
  AppliedLicense,
  AppliedLicenseIcon,
  AppliedLicenseInfo,
  AppliedLicenseName,
  AppliedLicenseDescription,
  AppliedLicensesBlock,
  AppliedLicenseWrapper,
  DesktopLicensesList,
  MobileLicensesList,
} from './styles'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'

const carouselSettings = {
  centerMode: true,
  centerPadding: '32px',
  infinite: false,
  swipeToSlide: true,
  arrows: false,
  dots: false,
  rows: 3,
  slidesPerRow: 1,
}

function AppliedLicenses() {
  const { homeId } = useHomeRouteParams()
  const history = useHistory()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const homeLicenses = useAppSelector<LicenseType[]>(homeAddedLicensesSelector)

  const openLicensingPage = () => {
    if (currentRootId) {
      const homeLicensingPath = generatePath(routes.homeLicensing, {
        homeId,
        rootDomainId: currentRootId,
      })
      history.push(homeLicensingPath)
    }
  }

  const licensesList = () =>
    homeLicenses.map((license) => (
      <AppliedLicenseWrapper key={license.id}>
        <AppliedLicense>
          <AppliedLicenseIcon path={mdiLicense} size={1} />
          <AppliedLicenseInfo>
            <AppliedLicenseDescription>
              {prettyLicenseDescription(license.description)}
            </AppliedLicenseDescription>
            <AppliedLicenseName>{license.name}</AppliedLicenseName>
          </AppliedLicenseInfo>
        </AppliedLicense>
      </AppliedLicenseWrapper>
    ))

  return (
    <AppliedLicensesBlock>
      <AppliedLicensesHeader>
        Applied Licenses
        <CommonLinkButton onClick={openLicensingPage}>
          <StyledIcon path={mdiArrowRight} size={1} />
        </CommonLinkButton>
      </AppliedLicensesHeader>
      <SubInfoBody>
        {homeLicenses?.length ? (
          <>
            <MobileLicensesList>
              <Carousel settings={carouselSettings}>{licensesList()}</Carousel>
            </MobileLicensesList>

            <DesktopLicensesList>{licensesList()}</DesktopLicensesList>
          </>
        ) : (
          <AppliedLicensesEmpty>No Licenses Applied</AppliedLicensesEmpty>
        )}
      </SubInfoBody>
    </AppliedLicensesBlock>
  )
}

export default AppliedLicenses
